export default __webpack_public_path__ + "static/media/service_website_development.872e596f.png";